<template>
  <div class="create-announcement">
    <div class="loader" v-if="loading"></div>
    <h1>Update Announcement</h1>

    <form ref="form">
      <div style="width: 100%" class="flex">
        <label style="width: 100%">
          Title:
          <input name="title" type="text" v-model="title" required maxlength="255"/>
          <div :style="{ color: charLimit(), width: '50px', 'margin-left': 'auto', 'text-align': 'right' }">
            <div style="font-size: 0.8em; position: relative; font-weight: normal; top: 10px;">{{title.length}}/255</div>
          </div>
        </label>
      </div>

      <div class="flex-top-align mt-2" style="width: 90%">
        <!-- <div style="margin: 0px; font-weight: bold">Regions:</div> -->
        <div>
          <label style="font-weight: 500">
            <input
              class="ml-2"
              type="checkbox"
              v-model="selectAll"
              @change="toggleAllRegions"
            />
            <img
              :src="this.all"
              style="height: 30px; margin-inline: 10px"
              title="All"
            />
          </label>
          <label
            style="font-weight: 500"
            v-for="region in regions"
            :key="region.id"
          >
            <input
              class="ml-2"
              type="checkbox"
              :disabled="selectAll"
              v-model="selectedRegions"
              :value="region.id"
              @change="toggleSelectRegionsPrompt"
            />
            <img
              :src="getRegionsImage(region.name)"
              style="height: 30px; margin-inline: 10px"
              :title="region.name"
            />
            <!-- {{ region.name }} -->
          </label>
        </div>
      </div>

      <div class="flex">
        <label>
          Start Date:
          <input name="start_date" type="date" v-model="startDate" required />
        </label>

        <label>
          End Date:
          <input id="endDateEle" name="end_date" type="date" v-model="endDate" required />
        </label>
      </div>

      <div>
        <label>Body:</label>
        <p style="font-size: 0.8em;"><em>Minimum resolution for optimal image display is:  <b>534 x 300</b></em> </p>
        <div
          style="min-height: 320px; height: 100%"
          id="editor"
          ref="editor"
          :required="true"
        ></div>
      </div>
    </form>

    <div class="buttons mt-4 mb-4">
      <button
        style="margin-right: auto"
        class="cancel-btn preview-btn"
        @click="goBack"
      >
        Cancel
      </button>
      <button
        class="preview-btn"
        @click="firePreview"
        :disabled="isPreviewDisabled()"
      >
        Preview
      </button>
      <button style="margin-left: 20px" @click="updateAnnouncement">
        Submit
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Quill from 'quill';
import Delta from 'quill-delta';
import Swal from 'sweetalert2';
import all from '../assets/all.png';
import australia from '../assets/australia.png';
import china from '../assets/china.png';
import hongkong from '../assets/hong-kong.png';
import india from '../assets/india.png';
import japan from '../assets/japan.png';
import malaysia from '../assets/malaysia.png';
import philippines from '../assets/philippines.png';
import singapore from '../assets/singapore.png';

export default {
  data() {
    return {
      all: all,
      australia: australia,
      china: china,
      hongkong: hongkong,
      india: india,
      japan: japan,
      malaysia: malaysia,
      philippines: philippines,
      singapore: singapore,
      selectedLayout: 'imageFirst',
      title: '',
      regions: [],
      selectedRegions: [],
      startDate: '',
      endDate: '',
      loading: false,
      body: '',
      editor: null,
      imageUploadedUrl: '',
      selectAll: false,
    };
  },
  mounted() {
    this.getRegions();
    this.initializeEditors();
  },
  methods: {
    charLimit() {
      return this.title.length == 255 ? 'red' : 'inherit';
    },
    getRegions() {
      this.loading = true;
      axios
        .get(this.$hostName + '/getRegions')
        .then((response) => {
          this.regions = response.data;
        })
        .catch((error) => console.error(error));
    },
    initializeEditors() {
      this.body = '';

      const quill = new Quill(this.$refs.editor, {
        theme: 'snow',
        // formats: ["bold", "italic", "underline", "strike", "image"],
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['image'],
            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: 'ordered' }, { list: 'bullet' }],
            // [{ align: [] }],
            ['clean'],
          ],
        },
      });

      this.editor = quill;
      this.editor.root.style.height = '320px';

      let host = this.$hostName;

      quill.on('text-change', () => {
        this.body = quill.root.innerHTML;
      });

      //adding image handler to store image in backend file system storage
      var toolbar = quill.getModule('toolbar');
      // var hostName = this.$hostName;
      toolbar.addHandler('image', function () {
        const range = this.quill.getSelection();
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();
        // input.onchange = () => {
        //   this.loadImage(range, input);
        // };
        input.onchange = function () {
          // console.log("Input image: " + range.index + input);
          var file = input.files[0];
          var formData = new FormData();
          formData.append('image', file);
          formData.append('url', process.env.VUE_APP_ANNOUNCEMENT_URL);
          formData.append(
            'image_path',
            process.env.VUE_APP_ANNOUNCEMENT_IMAGE_PATH
          );

          axios
            .post(host + '/upload-image', formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            })
            .then((response) => {
              // console.log(response);
              // let imagePath = response.data.path;
              this.imageUploadedPath = response.data.path;
              console.log('image path: ' + this.imageUploadedPath);
              quill.setSelection(range.index, 1);
              quill.updateContents(
                new Delta()
                  .retain(range.index)
                  .delete(1)
                  .insert({ image: this.imageUploadedPath })
              );

              const images = document.querySelectorAll('img');
              images.forEach((image) => {
                // Do something with each image element

                image.style.maxHeight = '300px';
                image.style.maxWidth = '534px';
              });
            })
            .catch((error) => console.error(error));
        };
      });

      //loading announcement data in fields
      this.loadAnnouncement();
    },

    loadAnnouncement() {
      axios
        .get(this.$hostName + '/getAnnouncement/' + this.$route.params.id)
        .then((response) => {
          console.log(response);

          const announcement = response.data;

          const regions = announcement.regions.map((region) => region.id);

          this.title = announcement.Title;
          this.body = announcement.Body;
          this.selectedRegions = regions;
          console.log(this.selectedRegions);

          this.startDate = announcement['Start Date'];
          this.endDate = announcement['End Date'];

          //setting min value for end date
          let dateobj = new Date(this.startDate);
          console.log('dateobj: ', dateobj);
          let endDate = `${dateobj.getFullYear()}-${dateobj.toLocaleString(
            'en',
            { month: '2-digit' }
          )}-${dateobj.toLocaleString('en', { day: '2-digit' })}`
          let endDateEle = document.getElementById('endDateEle');
          endDateEle.min = endDate;

          let images = JSON.parse(announcement.Image);

          //displaying body with image inserted

          let paras = this.body.split('..img..');
          console.log('Paras: ', paras);
          console.log('Images: ', images);
          // let body = '';
          // paras[0] + '<img src="' + this.imageUploadedUrl + '">' + paras[1];
          let parasWithImages = paras.map((para, index) => {
            return images[index]
              ? para +
                  '<img style="max-height: 300px; max-width: 534px" src="' +
                  images[index] +
                  '">'
              : para;
          });
          console.log('Para with images: ' + parasWithImages.join(' '));

          //inserting body into editor

          this.editor.root.innerHTML = parasWithImages.join('');

          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    updateAnnouncement() {
      console.log('body: ', this.extractTextFromHtml(this.body).trim().length == 0);
      console.log('img:', !this.checkForImgTags(this.body));
      if (this.title.trim().length == 0) {
        Swal.fire({
          icon: 'error',
          title: 'Please select atleast one region!',
          text: 'Regions can not be empty',
        });
      } else if (this.selectedRegions.length == 0) {
        Swal.fire({
          icon: 'error',
          title: 'Please select atleast one region!',
          text: 'Regions can not be empty',
        });
      } else if ((this.extractTextFromHtml(this.body).trim().length == 0) && !this.checkForImgTags(this.body)) {
        {
          Swal.fire({
          icon: 'error',
          title: 'Please enter body for the announcement!',
          text: 'Body can not be empty for the announcement',
        });
        }
      } else if (!this.startDate || !this.endDate) {
        Swal.fire({
          icon: 'error',
          title: 'Please select start and/or end dates!',
          text: 'Start and/or End Dates can not be empty',
        });
      } else {
        if (this.$refs.form.checkValidity()) {
          //formdata to send request

          const formData = new FormData(this.$refs.form);

          let regex = /<img\b[^>]*src=['"]([^'"]+)['"][^>]*>/g;
          let matches = this.body.match(regex);
          let urls = [];

          if (matches != null) {
            urls = matches.map(
              (match) => match.match(/src=['"]([^'"]+)['"]/)[1]
            );
          }

          // console.log(urls);
          // this.imageUploadedUrl = urls[0];

          // splitting editor content such that image is excluded and joined by: ..img..
          var body = this.body.split(/<img\b[^>]*>/g).join('..img..');

          formData.append('body', body);
          formData.append('start_date', this.startDate);
          formData.append('end_date', this.endDate);

          this.selectedRegions.forEach((regionId) => {
            formData.append('region_ids[]', regionId);
          });

          if (urls.length > 0) {
            urls.forEach((url) => {
              formData.append('image[]', url);
            });
          }

          console.log(formData);
          // formData.append("image", this.imageUploadedUrl);
          axios
            .post(
              this.$hostName + '/updateAnnouncement/' + this.$route.params.id,
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              }
            )
            .then((response) => {
              console.log(response);
              Swal.fire({
                icon: 'success',
                title: 'Announcement Updated',
                text: 'The announcement has been successfully updated!',
              });

              this.$router.push({
                name: 'announcements',
              });
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          this.$refs.form.reportValidity();
        }
      }
    },

    extractTextFromHtml(htmlstring) {
      let element = document.createElement('div');
      element.innerHTML = htmlstring;
      return element.textContent || element.innerText || '';
    },

    checkForImgTags(htmlString) {
      let regex = /<img[^>]*>/gi;
      let matches = htmlString.match(regex);
      // console.log("IMG TAGS: ", matches.length > 0);

      return matches ? true : false;
    },

    toggleAllRegions() {
      if (this.selectAll) {
        this.selectedRegions = this.regions.map((region) => region.id);
      } else {
        this.selectedRegions = [];
      }

      console.log('regions: ' + this.selectedRegions);
    },

    firePreview() {
      const previewData = {
        title: this.title,
        body: this.editor.root.innerHTML,
      };

      this.$emit('show-preview', previewData);
    },

    goBack() {
      this.$router.go(-1);
    },

    getRegionsImage(name) {
      switch (name) {
        case 'Australia':
          return australia;
        case 'China':
          return china;
        case 'Hong Kong':
          return hongkong;
        case 'India':
          return india;
        case 'Japan':
          return japan;
        case 'Malaysia':
          return malaysia;
        case 'Philippines':
          return philippines;
        case 'Singapore':
          return singapore;
      }
    },

    isPreviewDisabled() {
      if (
        this.body.length == 0 ||
        this.body === '<p><br></p>' ||
        this.title.trim().length == 0
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.snow.css";

.create-announcement {
  font-family: Montserrat;
  max-width: 86vw;
  margin: 0px auto;
  margin-top: 10px;
  // border: 1px solid black;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 0px;
  width: 70%;
  min-width: 400px;
}

.flex-top-align {
  display: flex;
  align-items: top;
}

h2 {
  font-size: 24px;
  margin-bottom: 20px;
}

form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

label {
  font-weight: bold;
}

#editor .ql-container {
  border: 1px solid black;
}

input[type="text"],
input[type="date"],
select {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
}

input[type="file"] {
  display: block;
  margin-top: 5px;
}

// textarea {
//   padding: 8px;
//   border: 1px solid #ccc;
//   border-radius: 4px;
//   width: 100%;
//   min-height: 100px;
// }

.buttons {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  // border: 1px solid black;
}

button {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

.preview {
  margin: 20px auto;
  margin-bottom: 0px;

  p {
    font-weight: bold;
  }
}

.preview-btn {
  // border: 1px solid black;
  background-color: transparent;
  color: black;
  border: 1.5px solid rgb(185, 185, 185);
}

.preview-btn:hover {
  background-color: #e7e7e7;
  border: 1.5px solid rgb(185, 185, 185);
}
</style>
